// Canonical Spanish comunidad autónoma names, shared between admin-interface
// (contract template "ccaa" variable editor) and user-interface (the
// "ccaa" variable's select in ContractVariablesPanel). Mirrors the backend's
// CANONICAL_CCAA_NAMES (backend/src/Shared/CcaaUtils.ts) — kept as a separate
// frontend copy rather than importing across the backend/frontend boundary.
export const CANONICAL_CCAA_NAMES = [
  'Andalucía',
  'Aragón',
  'Asturias',
  'Illes Balears',
  'Canarias',
  'Cantabria',
  'Castilla-La Mancha',
  'Castilla y León',
  'Cataluña',
  'Comunidad Valenciana',
  'Extremadura',
  'Galicia',
  'La Rioja',
  'Comunidad de Madrid',
  'Región de Murcia',
  'Navarra',
  'País Vasco',
  'Ceuta',
  'Melilla'
] as const

export type CanonicalCcaa = (typeof CANONICAL_CCAA_NAMES)[number]
